module.exports = __webpack_public_path__ + "img/XiTang2.59cc953b.jpg";